






















import { userDateFormat } from '@/domains/date'
import { UwInput } from '@ultraware/vee-form-handler'
import { QDate, QIcon, QPopupProxy } from 'quasar'
import { ValidationObserver } from 'vee-validate'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    QDate,
    QIcon,
    QPopupProxy,
    UwInput,
    ValidationObserver,
  },
})

export default class SelectDateRange extends Vue {
    @Prop({ required: true, default: null }) public value!: string | null;
    @Prop({ type: Boolean, default: false }) public required!: boolean;
    @Prop({ type: Function, default: (): boolean => true }) public options!: (_: string) => boolean;
    @Prop({ type: String, required: true }) public name!: string;

    get model(): string | null {
      return this.value
    }

    set model(v: string| null) {
      this.$emit('input', v)
    }

    public mask = userDateFormat
}
